export default "__VITE_ASSET__CQ6NPD3b__"